import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-board_node",
  "use": "icon-board_node-usage",
  "viewBox": "0 0 68 56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 56\" id=\"icon-board_node\"><path d=\"M68 0L51.065 56H4a4 4 0 01-4-4V4a4 4 0 014-4h64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol